export enum CALL_OPTIONS {
    SIGNAL_SERVER_URL = "wss://signaling.because-why-not.com/callapp",
    ICE_SERVER_URL = "turn:t.y-not.app:443",
    ICE_SERVER_USER = "user_nov",
    ICE_SERVER_PASSWORD = "pass_nov"
}